import { useTheme } from "styled-components";

import logo from "@sso/assets/basemap-logo.png";
import { PathKeys } from "@sso/constant";
import { useMediaQuery } from "@sso/hooks/useMediaQuery";
import { CommonPageMessageType } from "@sso/types";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { CustomLink } from "@sso/ui/CustomLink";
import { ColumnContainer, Flex } from "@sso/ui/FlexBox";
import { Img } from "@sso/ui/Img";
import { Typography } from "@sso/ui/Typography";

import { CommonPagesFooter } from "./CommonPagesFooter";

interface CommonPagesContentProps {
  message: CommonPageMessageType;
  loading: boolean;
}

export const CommonPagesContent = ({ message, loading }: CommonPagesContentProps) => {
  const theme = useTheme();
  const isMatchDownSm = useMediaQuery(`(max-width:${theme.breakpoints.sm})`);

  return (
    <>
      <ColumnContainer
        as="main"
        position="relative"
        height="80vh"
        minHeight="400px"
        bgColor={theme.colors.primary.light}
        justify="flex-start"
        padding="1.5rem"
      >
        <Flex width="100%" justify={isMatchDownSm ? "center" : "flex-start"}>
          <Img src={logo} alt="basemapLogo" width="200px" height="auto" loading="lazy" />
        </Flex>
        <ColumnContainer margin="auto 0" padding="1rem 2rem">
          {!loading && message && (
            <>
              <Typography
                size={isMatchDownSm ? "2.5rem" : "3rem"}
                margin={`1rem 0 ${isMatchDownSm ? "2rem" : "3rem"} 0`}
                color={theme.colors.action.disabled}
              >
                {message.header}
              </Typography>
              <Typography
                size={isMatchDownSm ? "1rem" : "1.2rem"}
                display="initial"
                lineHeight={1.5}
                color={theme.colors.grey[500]}
              >
                {message.title}
                <br />
                <br /> You can click{" "}
                <CustomLink to={PathKeys.SIGN_IN} color={theme.colors.primary.dark}>
                  Here
                </CustomLink>{" "}
                to start using your Basemap Cloud Workspace.
              </Typography>
            </>
          )}
          {loading && <CircleLoading size={10} />}
        </ColumnContainer>
      </ColumnContainer>
      <CommonPagesFooter />
    </>
  );
};
